module.exports = __webpack_public_path__ + "static/assets/eaeb48bb0997c81359942ee431680a8d.gif";